import { Header, FacilitySearch as FacilitySearchComponent } from "components"
export const FacilitySearch = () => {
 return (
  <div>
   <Header />
   <FacilitySearchComponent />
  </div>
 )
}
